"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("../constants");
var PersonalMeetingRoomUtil = {};
PersonalMeetingRoomUtil.getClaimPmrLink = function (pmrLink) {
  var validator = _constants.VALID_PMR_ADDRESS.test(pmrLink);
  if (validator) {
    return pmrLink;
  }
  validator = pmrLink.match(_constants.VALID_PMR_LINK);
  if (validator) {
    // userId + '@' + site + '.webex.com'
    return "".concat(validator[4], "@").concat(validator[2], ".").concat(_constants.WEBEX_DOT_COM);
  }
  return null;
};
PersonalMeetingRoomUtil.getClaimPmrPin = function (hostPin) {
  if (_constants.VALID_PIN.test(hostPin)) {
    return hostPin;
  }
  return null;
};
PersonalMeetingRoomUtil.getClaimedRequestParams = function (link, pin, options) {
  return {
    method: _constants.HTTP_VERBS.POST,
    api: _constants.HECATE,
    resource: "/".concat(_constants.CMR_MEETINGS, "/").concat(_constants.CLAIM),
    body: {
      userId: options.userId,
      passcode: pin,
      preferred: options.preferred,
      meetingAddress: link
    }
  };
};
var _default = PersonalMeetingRoomUtil;
exports.default = _default;
//# sourceMappingURL=util.js.map
